import { summaryItems } from "@/lib/auditPrint";

export const AuditSummary = ({ summary, periodLabel, techLabel, activity }) => {
  if (!summary) return null;
  return (
    <div className="card-base p-4" data-testid="audit-summary">
      <div className="flex flex-wrap gap-x-6 gap-y-1 text-xs text-slate-500 mb-3">
        <span data-testid="audit-summary-period">Período: <b className="text-slate-800">{periodLabel}</b></span>
        <span data-testid="audit-summary-technician">Técnico: <b className="text-slate-800">{techLabel}</b></span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 xl:grid-cols-9 gap-2">
        {summaryItems(summary, activity).map(([k, v], i) => (
          <div key={k} className="rounded-lg bg-slate-50 border border-slate-200 px-3 py-2" data-testid={`audit-summary-item-${i}`}>
            <div className="text-[11px] leading-tight text-slate-500">{k}</div>
            <div className="font-heading font-extrabold text-lg text-slate-900 tabular-nums">{v}</div>
          </div>
        ))}
      </div>
      {summary.finalized_without_snapshot > 0 && (
        <p className="text-[11px] text-amber-700 mt-2" data-testid="audit-summary-legacy-note">
          {summary.finalized_without_snapshot} equipo(s) finalizado(s) sin snapshot: su producción se toma del presupuesto vigente (regla existente).
        </p>
      )}
    </div>
  );
};
